import { useContext } from "react";
import * as Scrivito from "scrivito";
import cookieConsentIcon from "../assets/images/cookie_consent_icon.svg";
import getHomepage from "../utils/getHomepage";
import { CookieConsentContext } from "./CookieConsentContext";

function CookieConsent() {
  const { cookieConsent, acceptCookieConsent, declineCookieConsent } =
    useContext(CookieConsentContext);

  const currentPage = Scrivito.currentPage();
  if (!currentPage) {
    return null;
  }
  const lang = currentPage.language();
  const root = getHomepage(currentPage);
  const optionsPage = root?.get("optionsPage");
  const onOptionsPage = currentPage.id() === optionsPage?.id();

  if (!root) {
    return null;
  }

  if (onOptionsPage) {
    return null;
  }

  const consentUrl = root.get("cookieConsentLink");
  if (!consentUrl) {
    return null;
  }

  if (cookieConsent === "decided") {
    return null;
  }

  const onMoreOptions = () => {
    Scrivito.navigateTo(optionsPage);
  };

  return (
    <CookieBanner
      url={Scrivito.urlFor(consentUrl)}
      title={lang === "de" ? "Datenschutzerklärung »»" : "Privacy policy »»"}
      onAccept={acceptCookieConsent}
      onDecline={declineCookieConsent}
      onMoreOptions={onMoreOptions}
      optionsPage={optionsPage}
      lang={lang}
      root={root}
    />
  );
}

function CookieBanner({
  title,
  url,
  onAccept,
  onDecline,
  onMoreOptions,
  optionsPage,
  lang,
  root,
}) {
  const fallbackText =
    lang === "de" ? (
      <>
        <div className="cookie-box-title">Cookies policy</div>Um unsere Webseite
        für Sie optimal gestalten und verbessern zu können, verwenden wir
        Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der
        Verwendung von Cookies zu. Weitere Informationen zu Cookies erhalten Sie
        in unserer Datenschutzerklärung.
        <a
          className="cookie-box-link"
          href={url}
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          {title}
        </a>
      </>
    ) : (
      <>
        <div className="cookie-box-title">Cookies policy</div>We use cookies to
        design and improve our website perfectly for you. Using the website you
        accept the usage of cookies. Further information on cookies is provided
        for you in our privacy policy.
        <a
          className="cookie-box-link"
          href={url}
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          {title}
        </a>
      </>
    );
  return (
    <div
      data-lh-ignore
      className="cookie-box d-md-flex flex-columnm overflow-auto"
    >
      <div className="cookie-content d-flex">
        <div className="cookie-img-box">
          <img
            className="cookie-img"
            src={cookieConsentIcon}
            alt="cookie-img"
            width="50"
            height="50"
          />
        </div>
        <div className="cookie-text-column">
          <div className="cookie-text-scroll">
            {root.get("cookieBannerText") ||
            Scrivito.isInPlaceEditingActive() ? (
              <Scrivito.ContentTag
                content={root}
                attribute="cookieBannerText"
              />
            ) : (
              fallbackText
            )}
          </div>
          <div className="d-flex flex-column flex-lg-row cookie-button-row mt-3">
            <div className="col cookie-button-col ps-0">
              <button
                className="cookie-button btn bg-blue w-100 btn-block mb-2"
                onClick={onAccept}
              >
                {lang === "de" ? "Zustimmen" : "Accept"}
              </button>
            </div>
            <div className="col cookie-button-col px-lg-2">
              <button
                className="cookie-button btn bg-blue w-100 btn-block mb-2"
                onClick={onDecline}
              >
                {lang === "de" ? "Ablehnen" : "Decline"}
              </button>
            </div>
            {optionsPage && (
              <div className="col cookie-button-col pe-0">
                <button
                  className="cookie-button btn bg-blue w-100 btn-block py-0"
                  onClick={onMoreOptions}
                >
                  {lang === "de" ? "Weitere Einstellungen" : "More Options"}
                </button>
              </div>
            )}
          </div>
          <div className="cookie-banner-close">
            <button className="btn btn-link" onClick={onDecline}>
              <i className="las la-close"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scrivito.connect(CookieConsent);
